import { useTranslate } from '@festina-life/ui/hooks'

import { useVariantAction } from '../../../hooks/useVariantAction'
import { useHook } from '../../../lenteHooks'
import { CommandModalButton } from '../../commandActions/CommandModalButton'
import type { ActionButtonProps } from '../../commandActions/types'
import { AddFundMergeForm } from './AddFundMergeForm'

export const AddFundMergeCommand = (props: ActionButtonProps) => {
  const translate = useTranslate()

  const { tenantId, isinKey } = useHook('routing.general.useFundPricesParams')()
  const actions = useHook('mutators.unitlink.useAddFundMergeActions')({
    tenantId,
    isinKey,
    ...props,
  })

  const submit = useVariantAction({ ...props, actions })

  return (
    <CommandModalButton
      actionId="unitLink.AddFundMergeCommandData"
      title={translate('fund.actions.addFundMerge')}
      commandDataForm={AddFundMergeForm}
      submit={submit}
      {...props}
    />
  )
}
